/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {Mdx} from '../components/Mdx.js';
import {siteDiscord} from '../config.js';
const MDXLayout = function RoadmapPage(props) {
  return _jsx(Mdx, props);
};
export async function getStaticProps() {
  return {
    props: {
      i18nTitle: ['roadmapPage.title']
    }
  };
}
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      h2: "h2",
      ul: "ul",
      li: "li",
      a: "a",
      em: "em",
      code: "code"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h1, {
        children: "Wormhole Roadmap"
      }), "\n", _jsx("div", {
        className: "lead",
        children: _jsxs(_components.p, {
          children: ["Here's how we're planning to make Wormhole the best file sending tool. Let us\nknow if you have feature requests by joining our", ' ', "\n", _jsx("a", {
            href: siteDiscord,
            children: "Discord server"
          }), "!"]
        })
      }), "\n", _jsx(_components.h2, {
        children: "🚀 Shipped"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["📸 ", _jsx(_components.a, {
            href: "https://twitter.com/feross/status/1384695306646745095",
            children: "QR codes"
          }), " - Send files from desktop to mobile with ✨ ", _jsx(_components.em, {
            children: "one click"
          }), " ✨"]
        }), "\n", _jsxs(_components.li, {
          children: ["🔐 ", _jsx(_components.a, {
            href: "https://twitter.com/feross/status/1384320519202250753",
            children: "Open source cryptography code"
          }), " – Win up to $1,000 for finding security issues"]
        }), "\n", _jsxs(_components.li, {
          children: ["🌎 ", _jsx(_components.a, {
            href: "https://twitter.com/feross/status/1392221437180583938",
            children: "Internationalization"
          }), " – Wormhole in your language"]
        }), "\n", _jsxs(_components.li, {
          children: ["💻 ", _jsx(_components.a, {
            href: "https://www.microsoft.com/en-us/p/wormhole-app/9nnqv0rm2j9r",
            children: "Microsoft Store app"
          }), " – Use Wormhole on Windows 10, Xbox, or Hololens"]
        }), "\n", _jsxs(_components.li, {
          children: ["🧅 ", _jsx(_components.a, {
            href: "https://twitter.com/feross/status/1412507092716449795",
            children: "Tor Browser support"
          }), " – Use Wormhole on Tor Browser for the utmost privacy"]
        }), "\n", _jsxs(_components.li, {
          children: ["📋 ", _jsx(_components.a, {
            href: "https://twitter.com/feross/status/1412796046795808770",
            children: "Share files from clipboard"
          }), " – Use ", _jsx(_components.code, {
            children: "⌘+V"
          }), " or ", _jsx(_components.code, {
            children: "Ctrl+V"
          }), " to share files from clipboard"]
        }), "\n", _jsxs(_components.li, {
          children: ["👀 ", _jsx(_components.a, {
            href: "https://twitter.com/feross/status/1413160445997981698",
            children: "Inline media viewer"
          }), " – View images, audio, and videos without downloading"]
        }), "\n", _jsx(_components.li, {
          children: "⏰ Custom expiration – Select an expiration time and maximum download count"
        }), "\n", _jsx(_components.li, {
          children: "🎯 Web Share Target – Share files from any app to Wormhole (Android, Windows, Chrome OS)"
        }), "\n", _jsx(_components.li, {
          children: "💥 Delete button – Remove files before they expire"
        }), "\n", _jsx(_components.li, {
          children: "📍 Recent shares – Easily find your share links on the homepage"
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        children: "Future"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "🏆 Wormhole Pro – Longer expiration time, higher download count, larger files"
        }), "\n", _jsx(_components.li, {
          children: "📱 Android app – Get Wormhole from the Google Play store"
        }), "\n", _jsx(_components.li, {
          children: "🔒 Optional password protection  – Extra security for your files"
        }), "\n", _jsx(_components.li, {
          children: "📊 Download stats – See if/when your files were downloaded"
        }), "\n", _jsx(_components.li, {
          children: "🕸 Peer-to-peer Mode - No cloud, just pure P2P file transfers"
        }), "\n", _jsx(_components.li, {
          children: "📱 iPhone app – Get Wormhole from the App Store"
        }), "\n", _jsx(_components.li, {
          children: "🚦 Upload resumption – Don't lose your progress when your upload is interrupted"
        }), "\n", _jsx(_components.li, {
          children: "🦴 Background fetch – Finish uploading even if you close the tab before the upload is complete"
        }), "\n", _jsx(_components.li, {
          children: "📥 Request files – Link to receive files from anyone"
        }), "\n", _jsxs(_components.li, {
          children: ["❓ Let us know what we should work on by joining our ", _jsx("a", {
            href: siteDiscord,
            children: "Discord server"
          }), "!"]
        }), "\n"]
      })]
    });
  }
}
export default MDXContent;
